import { render, staticRenderFns } from "./InquiryRequestDetailsView.vue?vue&type=template&id=a7ec4778&scoped=true"
import script from "./InquiryRequestDetailsView.vue?vue&type=script&lang=js"
export * from "./InquiryRequestDetailsView.vue?vue&type=script&lang=js"
import style0 from "./InquiryRequestDetailsView.vue?vue&type=style&index=0&id=a7ec4778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ec4778",
  null
  
)

export default component.exports